module.exports = "../dist/img/white-17.e99a.jpg";